<template>
  <div>
    <headNavBar title="微信消息设置" :fixed="true" />
    <div class="mt-header-nav">
      <van-checkbox-group
        v-model="checkedList"
        ref="checkboxGroup"
        class="check-box"
      >
        <van-checkbox
          :name="item.Value"
          v-for="(item, index) in weChatOptions"
          :key="index"
          :value="item.Value"
          >{{ item.Desc }}</van-checkbox
        >
      </van-checkbox-group>
      <van-goods-action>
        <template slot="default">
          <van-row style="width:100%">
            <van-col span="12">
              <van-button size="large" @click="$router.push({ name: 'my' })">
                取消
              </van-button>
            </van-col>
            <van-col span="12">
              <van-button type="info" size="large" @click="onSubmit">
                确定
              </van-button>
            </van-col>
          </van-row>
        </template>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Button,
  GoodsAction,
  Row,
  Col,
  Notify,
} from "vant";
import { GetEnumDesc, GetUserInfo, EditWechatSetting } from "@/api/my.js";
import { mapState } from "vuex";
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [Row.name]: Row,
    [Col.name]: Col,
    [Notify.name]: Notify,
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  data() {
    return {
      checkedList: [],
      weChatOptions: [],
      userInfo: {},
    };
  },
  created() {
    GetEnumDesc().then(res => {
      this.weChatOptions = res.Data.OperationType;
      GetUserInfo({ Id: this.user.OperatorId }).then(res => {
        this.userInfo = res.Data;
        if (this.userInfo.WechatMessageSetting != -1) {
          this.weChatOptions.forEach(el => {
            if ((this.userInfo.WechatMessageSetting & el.Value) > 0) {
              this.checkedList.push(el.Value);
            }
          });
        }
      });
    });
  },
  methods: {
    onSubmit() {
      let attibutes = 0;
      if (!this.checkedList.length) {
        attibutes = -1;
      } else {
        this.checkedList.forEach(el => {
          attibutes = Number(attibutes) + Number(el);
        });
      }
      EditWechatSetting({
        Id: this.user.OperatorId,
        WechatSetting: attibutes,
      }).then(() => {
        Notify({ type: "success", message: "操作成功" });
        this.$router.push({ name: "my" });
      });
    },
  },
};
</script>

<style lang="less">
.check-box {
  padding: 30px;
  .van-checkbox {
    margin-bottom: 10px;
  }
}
</style>
